import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  Anomaly,
  AnomalyFeedback,
  AnomalyFeedbackType,
  AnomalyFilter,
  AnomalySeverity,
} from '@buda/app/types/anomaly.types';
import { Environment } from '@dice/app/types/env.type';
import { ENV } from '@dice/config.tokens';
import { Observable } from 'rxjs';

@Injectable()
export class AnomalyApiService {
  private httpClient = inject(HttpClient);

  private readonly baseUrl: string = '';

  private readonly FEEDBACK: string = 'feedback/';

  private readonly BUSINESS_STRUCTURES: string = 'businessStructure/';

  constructor() {
    const env = inject<Environment>(ENV);

    this.baseUrl = env.anomalyEndpoint;
  }

  getAnomalies(anomalyFilter?: AnomalyFilter): Observable<Anomaly[]> {
    const filter = anomalyFilter || {};
    return this.httpClient.post<Anomaly[]>(this.baseUrl, filter);
  }

  getAnomalyById(anomalyId: string): Observable<Anomaly> {
    return this.httpClient.get<Anomaly>(this.baseUrl + anomalyId);
  }

  updateAnomalyFeedback(anomalyId: string, feedback: AnomalyFeedback): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl + anomalyId}/${this.FEEDBACK}`, feedback);
  }

  fetchBusinessStructures(businessUnit?: string): Observable<string[]> {
    return this.httpClient.get<string[]>(this.baseUrl + this.BUSINESS_STRUCTURES + businessUnit);
  }

  fetchFeedBackTypes(isFilter: boolean): Observable<AnomalyFeedbackType[]> {
    const queryString = isFilter ? `?filter=${isFilter}` : '';
    return this.httpClient.get<AnomalyFeedbackType[]>(`${this.baseUrl}feedback_types${queryString}`);
  }

  fetchSeverityTypes(): Observable<AnomalySeverity[]> {
    return this.httpClient.get<AnomalySeverity[]>(`${this.baseUrl}severity_types`);
  }
}
